<template>
    <section id="footer">
        <FooterBanner></FooterBanner>
        <FooterTop :info="footerInfo?.footer_menu"></FooterTop>
        <FooterBody :info="footerInfo?.compliance_menu"></FooterBody>
        <FooterBottom :copyright="footerInfo?.compliance_menu?.copyright?.[1]"></FooterBottom>
    </section>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import FooterBanner from './FooterModels/FooterBanner.vue'
import FooterTop from './FooterModels/FooterTop.vue'
import FooterBody from './FooterModels/FooterBody.vue'
import FooterBottom from './FooterModels/FooterBottom.vue'
import { getFooter } from '@/api/publicCms'

const footerInfo = ref({});

const { locale } = useI18n({ useScope: 'global' });

async function handleGetFooter() {
  const data = await getFooter(locale.value, window.location.origin);
  if (data) {
    footerInfo.value = data?.data;
  }
}

onMounted(async () => {
  await handleGetFooter();
});

watch(locale, async () => {
  await handleGetFooter();
});

</script>

<style lang="less" scoped >
@import '../../less/mediaQuery.less';

#footer {
    margin-top: 160px;

    @media @mobile-screen {
        margin-top: 80px;
    }
}</style>
